import React from 'react'
type Props = {
  width?: string
  height?: string
  color?: string
}

function Running({ width = '24', height = '24', color = '#6268AF' }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='12'
        cy='12'
        r='12'
        fill='#6268AF'
      />
      <path
        d='M8.5 8.49476C8.5 8.00917 8.5 7.76638 8.60125 7.63255C8.68945 7.51595 8.82426 7.4438 8.9702 7.43509C9.13772 7.42509 9.33973 7.55976 9.74376 7.82912L15.0015 11.3343C15.3354 11.5569 15.5023 11.6681 15.5605 11.8084C15.6113 11.931 15.6113 12.0689 15.5605 12.1915C15.5023 12.3317 15.3354 12.443 15.0015 12.6656L9.74376 16.1708C9.33973 16.4401 9.13772 16.5748 8.9702 16.5648C8.82426 16.5561 8.68945 16.4839 8.60125 16.3673C8.5 16.2335 8.5 15.9907 8.5 15.5051V8.49476Z'
        stroke='white'
        strokeWidth='1.2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default Running
